import React from 'react';
import styles from './ProgressBar.module.scss';

function ProgressBar({ progress, classes, step, totalStep, label }) {
  return (
    <>
      <div className={`${styles.progressCustomisation} ${classes}`}>
        <div
          className={`${styles.progressCustomisationBar}`}
          role="progressbar"
          style={{ width: `${progress}%`, transition: '0.5s all' }}
        />
      </div>
      <div className={styles.stepsRow}>
        {label && <span className={styles.progressLabel}>{label}</span>}
        <span className={styles.steps}>{`${step} of ${totalStep}`}</span>
      </div>
    </>
  );
}

export default ProgressBar;
